<template>
  <div
    class="c-app flex-row align-items-center"
    style="
         height: 100%;
        background-position: center;
        width: 100%;"
  >
    <CWrapper>
      <CHeader fixed with-subheader light style="position: fixed;">
        <CToggler
          in-header
          class="ml-3 d-lg-none"
          @click="$store.commit('toggleSidebarMobile')"
        />
        <CToggler
          in-header
          class="ml-3 d-md-down-none"
          @click="$store.commit('toggleSidebarDesktop')"
        />
        <CHeaderBrand class="d-lg-none">
          <h3>
            <b> <font color="Green">HRM</font></b>
          </h3>
        </CHeaderBrand>
        <CHeaderNav class="d-md-down-none mr-auto">
          <CHeaderNavItem class="px-3">
            <h3>
              <b> <font color="Green">HRM</font></b>
            </h3>
          </CHeaderNavItem>
        </CHeaderNav>
      </CHeader>
      <div class="c-body">
        <main class="c-main">
          <CRow>
            <CCol class="amsys-dashboard-parameter2">
              <select
                class="form-control"
                style="font-weight: bold; font-size:18px;"
                @change="reloadMonth()"
                v-model="selectedMonth"
              >
                <option value="0">
                  ALL
                </option>
                <option value="1">
                  JAN
                </option>
                <option value="2">
                  FEB
                </option>
                <option value="3">
                  MAR
                </option>
                <option value="4">
                  APR
                </option>
                <option value="5">
                  MEI
                </option>
                <option value="6">
                  JUN
                </option>
                <option value="7">
                  JUL
                </option>
                <option value="8">
                  AUG
                </option>
                <option value="9">
                  SEP
                </option>
                <option value="10">
                  OCT
                </option>
                <option value="11">
                  NOV
                </option>
                <option value="12">
                  DEC
                </option>
              </select>
            </CCol>
            <br />
            <CCol class="amsys-dashboard-parameter2">
              <select
                class="form-control"
                style="font-weight: bold; font-size:18px;"
                @change="reloadYear()"
                v-model="selectedYear"
              >
                <option
                  v-for="year in years()"
                  v-if="year >= 2015"
                  :value="year"
                  >{{ year }}</option
                >
              </select>
            </CCol>
          </CRow>
          <br />
          <CRow class="amsys-dashboard-row">
            <CCol class="amsys-dashboard-frame">
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b> <font color="white">Employee Turnover Rate</font></b>
                  </h5>
                </div>
                <div class="card-body" style="padding:0rem;">
                  <CCol style="width: 100%;padding: 0px;">
                    <table>
                      <tr>
                        <td style="font-weight: bold;">Name</td>
                        <td style="font-weight: bold;">Beginning</td>
                        <td style="font-weight: bold;">Joined</td>
                        <td style="font-weight: bold;">Resigned</td>
                        <td style="font-weight: bold;">Ending</td>
                        <td style="font-weight: bold;">TOR</td>
                      </tr>
                      <tr v-for="item in this.data" :key="item.Oid">
                        <td>{{ item.Code }}</td>
                        <td>{{ item.Beginning }}</td>
                        <td>{{ item.Joined }}</td>
                        <td>{{ item.Resigned }}</td>
                        <td>{{ item.Ending }}</td>
                        <td>{{ (item.TOR * 100).toFixed(2) }}%</td>
                      </tr>
                    </table>
                  </CCol>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow>
            <div
              class="col-md-h amsys-approval-card"
              style="padding-top: 15px;"
            >
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b> <font color="white">Employee By Division</font></b>
                  </h5>
                </div>
                <div class="card-body" style="padding:0rem;">
                  <CCol style="width: 100%;padding: 0px;">
                    <DxPieChart
                      id="pie"
                      :data-source="division"
                      palette="Bright"
                    >
                      <DxSeries argument-field="bep" value-field="qty">
                        <DxLabel
                          :visible="false"
                          :customize-text="formatLabel"
                          position="columns"
                        >
                          <DxConnector :visible="true" :width="0.5" />
                          <DxFont :size="16" />
                        </DxLabel>
                      </DxSeries>
                      <DxLegend
                        :column-count="4"
                        orientation="horizontal"
                        item-text-position="right"
                        horizontal-alignment="center"
                        vertical-alignment="bottom"
                      />
                      <DxTooltip
                        :enabled="true"
                        :customize-tooltip="pieCustomizeTooltip"
                      />
                      <DxExport :enabled="false" />
                    </DxPieChart>
                  </CCol>
                </div>
              </div>
            </div>
            <div
              class="col-md-h amsys-approval-card"
              style="padding-top: 15px;"
            >
              <div class="card">
                <div class="card-header" style="background-color:Green;">
                  <h5>
                    <b> <font color="white">Employee By Domicile</font></b>
                  </h5>
                </div>
                <div class="card-body" style="padding:0rem;">
                  <CCol style="width: 100%;padding: 0px;">
                    <DxPieChart
                      id="pie"
                      :data-source="domicile"
                      palette="Bright"
                    >
                      <DxSeries argument-field="bep" value-field="qty">
                        <DxLabel
                          :visible="false"
                          :customize-text="formatLabel"
                          position="columns"
                        >
                          <DxConnector :visible="true" :width="0.5" />
                          <DxFont :size="16" />
                        </DxLabel>
                      </DxSeries>
                      <DxLegend
                        :column-count="4"
                        orientation="horizontal"
                        item-text-position="right"
                        horizontal-alignment="center"
                        vertical-alignment="bottom"
                      />
                      <DxTooltip
                        :enabled="true"
                        :customize-tooltip="pieCustomizeTooltip"
                      />
                      <DxExport :enabled="false" />
                    </DxPieChart>
                  </CCol>
                </div>
              </div>
            </div>
          </CRow>
          <br />
        </main>
      </div>
    </CWrapper>
  </div>
</template>
<script>
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { DxPieChart, DxConnector } from "devextreme-vue/pie-chart";
import {
  DxSeries,
  DxLegend,
  DxLabel,
  DxFont,
  DxExport,
  DxTooltip,
  DxChart,
  DxCommonSeriesSettings,
  DxArgumentAxis,
  DxGrid,
  DxCrosshair,
  DxPoint,
  DxTitle,
  DxSubtitle,
  DxValueAxis,
} from "devextreme-vue/chart";
import TheSidebar from "../../containers/TheSidebar";
import TheHeader from "../../containers/TheHeader";
import nav from "../../containers/_nav";
import Vue from "vue";
import axios from "axios";
import "@babel/polyfill";
import VueCordova from "vue-cordova";
import CryptoJS from "crypto-js";
Vue.use(VueCordova);

export default {
  components: {
    DxChart,
    DxCommonSeriesSettings,
    DxSeries,
    DxArgumentAxis,
    DxGrid,
    DxCrosshair,
    DxExport,
    DxLegend,
    DxPoint,
    DxLabel,
    DxFont,
    DxTitle,
    DxSubtitle,
    DxTooltip,
    TheSidebar,
    TheHeader,
    DxValueAxis,
    DxPieChart,
    DxConnector,
  },
  nav,
  computed: {},
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      selectedMonth: new Date().getMonth() + 1,
      month: "",
      year: "",
      data: [],
      domicile: [],
      division: [],

      urlServer: "",
    };
  },
  methods: {
    formatLabel(pointInfo) {
      return `${pointInfo.value}`;
    },
    show() {
      return this.$store.state.sidebarShow;
    },
    Minimize() {
      return this.$store.state.sidebarMinimize;
    },
    customizeLabel({ value }) {
      return {
        customizeText: function({ valueText }) {
          return `${valueText
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
        },
      };
    },
    customizeText({ valueText }) {
      return `${valueText
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
    },
    customizeTooltip(pointInfo) {
      return {
        text: `${pointInfo.argumentText}
                            <br/>${pointInfo.value
                              .toFixed(2)
                              .toString()
                              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`,
      };
    },
    pieCustomizeTooltip(pointInfo) {
      return {
        text: `${pointInfo.argumentText}
                            <br/>${pointInfo.value}
                            <br/>${pointInfo.percentText}`,
      };
    },
    years() {
      const year = new Date().getFullYear();
      return Array.from(
        { length: year - 1900 },
        (value, index) => 1901 + index
      );
    },
    reloadMonth() {
      this.reloadData();
    },
    reloadYear() {
      this.reloadData();
    },
    reloadData() {
      let data = localStorage.token;
      var _division = new Array();
      var _domicile = new Array();
      var month = "";
      if (this.selectedMonth < 10) {
        month = "0" + this.selectedMonth.toString();
      } else {
        month = this.selectedMonth.toString();
      }
      var period = this.selectedYear.toString() + month;
      const param = {
        Period: period,
      };
      axios
        .post(`${this.urlServer}/Api/Dashboard/EmployeeTurnOverRate/`, param, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          console.log(res);
          this.data = res.data;
        })
        .catch((error) => {
          let err = error.toString();
          if (err.toString().match(/^.*undefined.*$/)) {
            Vue.$toast.open({
              message: "Sorry, Your token has expired!",
              type: "warning",
              position: "bottom",
            });
            this.$router.push({ path: "/logout" });
          } else {
            Vue.$toast.open({
              message: error,
              type: "error",
              position: "bottom",
            });
          }
        });

      axios
        .post(`${this.urlServer}/Api/Dashboard/EmployeeByDivision/`, param, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          res.data.forEach(function(entry) {
            var obj = new Object();
            obj["bep"] = entry.Name;
            obj["qty"] = parseFloat(entry.EmployeeCount);
            _division.push(obj);
          });
          this.division = _division;
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
        });

      axios
        .post(`${this.urlServer}/Api/Dashboard/EmployeeByDomicile/`, param, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          res.data.forEach(function(entry) {
            var obj = new Object();
            obj["bep"] = entry.Name;
            obj["qty"] = parseFloat(entry.EmployeeCount);
            _domicile.push(obj);
          });
          this.domicile = _domicile;
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
        });

      this.loading = false;
    },
  },
  beforeMount() {
    const stringToProtect = "Amsys_2@2021";
    let url = CryptoJS.AES.decrypt(localStorage.url, stringToProtect);
    this.urlServer = url.toString(CryptoJS.enc.Utf8);
    this.loading = true;
    this.reloadData();
    this.loading = false;
  },
};
</script>
<style>
#chart {
  height: 440px;
}

.tooltip-header {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 5px;
  border-bottom: 1px solid #c5c5c5;
}

.tooltip-body {
  width: 170px;
}

.tooltip-body .series-name {
  font-weight: normal;
  opacity: 0.6;
  display: inline-block;
  line-height: 1.5;
  padding-right: 10px;
  width: 126px;
}

.tooltip-body .value-text {
  display: inline-block;
  line-height: 1.5;
  width: 30px;
}
</style>
